/* eslint-disable */
export default function getQuestionType(num) {
    let type = null;
    switch (num) {
        case "1":
            type = "trueOrFalse";
            break;
        case "2":
            type = "multipleChoices";
            break;
        case "3":
            type = "freeText";
            break;
        case "4":
            type = "rank";
            break;
        case "5":
            type = "arrange";
            break;
    }

    return type;
}
